/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Info_Messages_UsedInputs */

const es_user_profile_info_messages_used = /** @type {(inputs: User_Profile_Info_Messages_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensajes usados este mes`)
};

const en_user_profile_info_messages_used = /** @type {(inputs: User_Profile_Info_Messages_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messages used this month`)
};

/**
* | output |
* | --- |
* | "Messages used this month" |
*
* @param {User_Profile_Info_Messages_UsedInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_info_messages_used = /** @type {((inputs?: User_Profile_Info_Messages_UsedInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Info_Messages_UsedInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_info_messages_used(inputs)
	return en_user_profile_info_messages_used(inputs)
});
export { user_profile_info_messages_used as "user.profile.info.messages_used" }